export const REQUEST_STATUS = {
	NONE: '',
	PENDING: 'PENDING',
	COMPLETE: 'COMPLETE',
	ERROR: 'ERROR'
};
